<template>
    <div class="textarea-wrapper">
        <div v-for="(item, index) in areaData" :key="index" class="area-list">
            <div class="item-num">{{ index + 1 }}</div>
            <div class="item-textarea">
                <div class="textarea-box">
                    <textarea
                        :maxlength="2000"
                        class="textarea"
                        :style="item.style"
                        v-model="item.content"
                        :placeholder="placeholder + (index + 1)"
                        @input="changeHandle(item.content, index)"
                        @focus="focus(index)"
                        @blur="blur(index)"
                    ></textarea>
                    <span class="remain-num"> {{ item.remianLen ? item.remianLen : 2000 }}/{{ 2000 }}</span>
                </div>
                <div class="del-cir" v-show="item.hasDelete" @click="delHandle(index)"><i class="i-del"></i></div>
            </div>
        </div>
        <div class="add-btn">
            <div class="btn-item-add" @click="addClick"><i class="ico-ten"></i></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Textarea",
    props: ["data"],
    data() {
        return {
            areaData: [],
            placeholder: this.$t("zhiji.form.terminology")
        };
    },
    mounted() {
        this.$emit("changeHandle", this.areaData);
    },
    watch: {
        data(val) {
            this.initDataHandle(val);
        }
    },
    methods: {
        initDataHandle(data) {
            if (data.length > 0) {
                this.areaData = data.map(item => {
                    return Object.assign(getInitItem(), {
                        content: item.content,
                        remianLen: 2000 - item.content.length
                    });
                });
            } else if (data.length === 0) {
                this.areaData = [];
                this.areaData.push(getInitItem());
            }
        },
        changeHandle(content, index) {
            let maxLen = 2000;
            this.areaData[index].remianLen = Number(maxLen) - content.length;
        },
        focus(index) {
            this.areaData[index].style = { height: "268px", "border-color": "#2088f3" };
            this.areaData[index].hasDelete = true;
        },
        blur(index) {
            setTimeout(() => {
                this.$emit("changeHandle", this.areaData);
                this.areaData[index].hasDelete = false;
                this.areaData[index].style = { height: "52px", "border-color": "#dcdfe6" };
            }, 200);
        },
        delHandle(index) {
            if (this.areaData.length > 1) {
                this.areaData.splice(index, 1);
                this.$emit("changeHandle", this.areaData);
            }
        },
        addClick() {
            if (this.areaData.length >= 5) {
                this.$store.commit("zhiji/showModal", {
                    type: "messageModal",
                    data: {
                        type: "tip",
                        message: this.$t("zhiji.form.autoAddTip")
                    }
                });

                return;
            }

            this.areaData.push(getInitItem());
            this.$emit("changeHandle", this.areaData);
        }
    }
};

function getInitItem() {
    return {
        content: "",
        style: {
            height: "34px"
        },
        hasDelete: false
    };
}
</script>

<style lang="scss" scoped>
.textarea-wrapper {
    margin-top: 10px;

    .area-list {
        display: flex;
        margin-top: 12px;

        .item-num {
            margin-right: 12px;
            margin-top: 10px;
            width: 20px;
            height: 20px;
            background: #549cf4;
            border-radius: 50%;
            color: #fff;
            text-align: center;
            line-height: 20px;
        }

        .textarea-box {
            position: relative;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            background: #fff;
            .textarea {
                padding: 8px;
                margin-bottom: 25px;
                display: flex;
                border-radius: 4px;
                flex: 1;
                height: 32px;
                width: 594px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 5px;
                    height: 5px;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 5px;
                    background: rgba(201, 201, 201, 0.6);
                }
            }

            .remain-num {
                position: absolute;
                bottom: 5px;
                right: 5px;
                font-size: 12px;
                color: #9b9ba3;
            }
        }

        .del-cir {
            cursor: pointer;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
            background: #fff;
            text-align: center;
            margin-left: 12px;
            margin-top: 17px;

            .i-del {
                display: inline-block;
                width: 16px;
                height: 18px;
                margin: 3px 5px 0 5px;
                vertical-align: middle;
                background: url($zhijiStaticImagePath+"class-spr.png");
                background-position: -96px 0;

                &:hover {
                    background-position: -96px -22px;
                }
            }
        }
    }

    .item-textarea {
        display: flex;
        flex: 1;

        &:hover {
            .del-cir {
                display: block !important;
            }
        }
    }

    .add-btn {
        margin-top: 8px;
        width: 629px;
        display: flex;
        justify-content: flex-end;

        .btn-item-add {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 76px;
            height: 32px;
            background: #ffffff;
            border: 1px solid #d8e4f0;
            border-radius: 20px;
            cursor: pointer;

            .ico-ten {
                display: inline-block;
                width: 14px;
                height: 14px;
                vertical-align: middle;
                background: url($zhijiStaticImagePath+"class-spr.png");
                background-position: -297px -1px;
            }

            &:hover .ico-ten {
                background-position: -223px -100px;
            }
        }
    }
}
</style>
